import { GlobalState } from '../../types/state';
import { useSelector } from 'react-redux';
import { TermsAndConditionsDialog } from './TermsAndConditionsdialog';
import { JBErrorModalWrapper } from './JBErrorModalWrapper';
import { ConfigureProductModal } from '../PrivateBanking/modals/ConfigureProductModal/ConfigureProductModal';
import { AddBankingProductsModal } from '../PrivateBanking/modals/AddBankingProductsModal';
import AddPortfolioDialog from '../../components/portfolio/AddPortfolioDialog';
import EditPortfolioDialog from '../../components/portfolio/EditPortfolioDialog';
import AddCashAccountDialog from '../../components/portfolio/AddCashAccountDialog';
import { ElementType } from 'react';

const modalComponentLookupTable: Record<string, ElementType> = {
  JBErrorModalWrapper,
  TermsAndConditionsDialog,
  ConfigureProductModal,
  AddBankingProductsModal,
  AddPortfolioDialog,
  EditPortfolioDialog,
  AddCashAccountDialog,
};

const selectCurrentModals = (state: GlobalState) => state.modal;

const ModalManager = () => {
  const currentModals = useSelector(selectCurrentModals);

  const renderedModals = currentModals.map((modalDescription, index) => {
    const { modalType, modalProps = {} } = modalDescription;
    const ModalComponent = modalComponentLookupTable[modalType];

    if (!ModalComponent) return null;

    return <ModalComponent {...modalProps} key={modalType + index} />;
  });

  return <span data-testid="modal-manager">{renderedModals}</span>;
};

export { ModalManager };
